export const defaultGalleryImage = '/recipientBg.png';
